import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-79d18e63"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "page"
}
const _hoisted_3 = { class: "d-flex" }
const _hoisted_4 = { class: "page-title" }
const _hoisted_5 = { class: "__allAlerts" }
const _hoisted_6 = { class: "alert-card" }
const _hoisted_7 = { class: "truncate-text" }
const _hoisted_8 = { class: "truncate-text" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Estación:", -1))
const _hoisted_10 = { class: "truncate-text" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("b", null, "Fecha de creacion: ", -1))
const _hoisted_12 = { class: "alert alert-group laptop" }
const _hoisted_13 = ["title"]
const _hoisted_14 = ["title"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bell fas" }, null, -1))
const _hoisted_16 = { class: "alert alert-group phone" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-ellipsis-v fas" }, null, -1))
const _hoisted_18 = ["title"]
const _hoisted_19 = ["title"]
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("em", { class: "el-icon el-icon-bell fas" }, null, -1))
const _hoisted_21 = { class: "footer" }
const _hoisted_22 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_alert_station_form_component = _resolveComponent("alert-station-form-component")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_ctx.$t("warning.notData")), 1))
      : _createCommentVNode("", true),
    (_ctx.hasData)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createVNode(_component_el_card, { class: "header" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("text.alertStation")), 1)
                ])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alerts, (item) => {
              return (_openBlock(), _createElementBlock("div", {
                key: item.id
              }, [
                _createVNode(_component_el_card, {
                  id: item.id,
                  class: _normalizeClass(item.active ? 'active' : 'inactive')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_6, [
                      _createVNode(_component_el_col, { span: 26 }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_tooltip, {
                            content: `Nombre de la alerta: ${item.name}`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("h3", _hoisted_7, [
                                _createElementVNode("b", null, _toDisplayString(item.name), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"]),
                          (item.parameterStationAlerts && item.parameterStationAlerts[0].station)
                            ? (_openBlock(), _createBlock(_component_el_tooltip, {
                                key: 0,
                                content: `Estación: ${item.parameterStationAlerts[0].station.name}`,
                                placement: "top"
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("p", _hoisted_8, [
                                    _hoisted_9,
                                    _createTextVNode(" " + _toDisplayString(item.parameterStationAlerts[0].station.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["content"]))
                            : _createCommentVNode("", true),
                          _createVNode(_component_el_tooltip, {
                            content: `Fecha de creacion: ${
                  item.dateTime !== undefined
                    ? _ctx.$d(new Date(item.dateTime.toLocaleString()), 'dateTimeNoSecs')
                    : ''
                }`,
                            placement: "top"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("p", _hoisted_10, [
                                _hoisted_11,
                                _createTextVNode(" " + _toDisplayString(item.dateTime !== undefined
                      ? _ctx.$d(new Date(item.dateTime.toLocaleString()), "dateTimeNoSecs")
                      : ""), 1)
                              ])
                            ]),
                            _: 2
                          }, 1032, ["content"])
                        ]),
                        _: 2
                      }, 1024),
                      _createVNode(_component_el_col, {
                        class: "grid-content",
                        span: 6
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_12, [
                            _createVNode(_component_el_row, {
                              span: 8,
                              gutter: 8
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.deleteAlert(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-trash fas",
                                          title: _ctx.$t('btn.delete')
                                        }, null, 8, _hoisted_13)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.openEntityFormDialog(item))
                                    }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("em", {
                                          class: "el-icon el-icon-edit fas",
                                          title: _ctx.$t('btn.edit')
                                        }, null, 8, _hoisted_14)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_button, {
                                      type: "default",
                                      class: "btn-group",
                                      onClick: ($event: any) => (_ctx.goToAlerts(item.id?.toString()))
                                    }, {
                                      default: _withCtx(() => [
                                        _hoisted_15
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_el_col, { span: 6 }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_switch, {
                                      modelValue: item.active,
                                      "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                                      class: "switch",
                                      onClick: ($event: any) => (_ctx.deactivateAlert(item))
                                    }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_el_dropdown, null, {
                              dropdown: _withCtx(() => [
                                _createVNode(_component_el_dropdown_menu, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_el_dropdown_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "default",
                                          onClick: ($event: any) => (_ctx.deleteAlert(item))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("em", {
                                              class: "el-icon el-icon-trash fas",
                                              title: _ctx.$t('btn.delete')
                                            }, null, 8, _hoisted_18)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_dropdown_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "default",
                                          onClick: ($event: any) => (_ctx.openEntityFormDialog(item))
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("em", {
                                              class: "el-icon el-icon-edit fas",
                                              title: _ctx.$t('btn.edit')
                                            }, null, 8, _hoisted_19)
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_dropdown_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_button, {
                                          type: "default",
                                          class: "btn-group",
                                          onClick: ($event: any) => (_ctx.goToAlerts(item.id?.toString()))
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_20
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"])
                                      ]),
                                      _: 2
                                    }, 1024),
                                    _createVNode(_component_el_dropdown_item, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_el_switch, {
                                          modelValue: item.active,
                                          "onUpdate:modelValue": ($event: any) => ((item.active) = $event),
                                          onClick: ($event: any) => (_ctx.deactivateAlert(item))
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"])
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_el_button, {
                                  class: "btn-border",
                                  circle: ""
                                }, {
                                  default: _withCtx(() => [
                                    _hoisted_17
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1024)
                          ])
                        ]),
                        _: 2
                      }, 1024)
                    ])
                  ]),
                  _: 2
                }, 1032, ["id", "class"])
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _createVNode(_component_el_pagination, {
              class: "app-table",
              layout: "total, sizes, prev, pager, next, jumper",
              currentPage: _ctx.currentPage,
              "onUpdate:currentPage": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.currentPage) = $event)),
              "page-sizes": [10, 20, 50, 100],
              "page-size": _ctx.rowPerPage,
              total: _ctx.totalRows,
              onSizeChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePaginationSize($event))),
              onCurrentChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.changePaginationPage($event)))
            }, null, 8, ["currentPage", "page-size", "total"])
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showAlertForm,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.showAlertForm) = $event)),
      title: _ctx.$t(_ctx.alertSelected?.id ? 'label.alertEdit' : 'label.alertNew'),
      "destroy-on-close": "",
      width: "55%",
      "custom-class": "app-form"
    }, {
      footer: _withCtx(() => [
        _createElementVNode("span", _hoisted_22, [
          _createVNode(_component_el_button, {
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeAlertDialog()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.cancel")), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.saveAlert()))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("btn.save")), 1)
            ]),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createVNode(_component_alert_station_form_component, {
          ref: "alertStationForm",
          id: _ctx.alertSelected?.id
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["modelValue", "title"])
  ], 64))
}